// extracted by mini-css-extract-plugin
export var modal = "_tk-0";
export var table = "_tk-1";